import { AfterViewInit, Component, computed, ElementRef, viewChild } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';

import { CipoControlBase } from '@shared/components/fields/cipo-control.base';
import { CipoTextConfig } from '@shared/components/fields/common';
import { CipoFormModule } from '@shared/modules/forms.module';
import { CipoTextViewComponent } from '../cipo-text-view/cipo-text-view.component';

@Component({
  selector: 'cipo-text',
  imports: [CipoFormModule, CipoTextViewComponent],
  templateUrl: './cipo-text.component.html',
})
export class CipoTextComponent extends CipoControlBase<string | string[], CipoTextConfig> implements AfterViewInit {
  chipInput = viewChild<ElementRef<HTMLInputElement>>('chipInput');
  textInput = viewChild<ElementRef<HTMLInputElement>>('textInput');
  autosizeMaxRows = computed(() => {
    const fieldData = this.fieldData();
    return fieldData?.maxRows ?? (fieldData?.position?.rows ? fieldData.position.rows * 4 : undefined);
  });
  selectedChipIndex: number;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    if (this.fieldData()?.focused && this.textInput()) {
      setTimeout(() => {
        this.textInput().nativeElement.focus();
      });
    }
  }

  add({ value, chipInput }: MatChipInputEvent) {
    if (!value) {
      return;
    }
    const values = (this.control().value || []) as string[];
    if (this.selectedChipIndex !== undefined) {
      values.splice(this.selectedChipIndex, 1, value);
      this.selectedChipIndex = undefined;
    } else {
      values.push(value);
    }
    chipInput.clear();
    this.control().setValue(values);
  }

  edit(index: number) {
    this.selectedChipIndex = index;
    this.chipInput().nativeElement.value = this.control().value[index];
    const values = this.control().value as string[];
    this.control().setValue(values);
    this.chipInput().nativeElement.focus();
  }

  remove(index: number) {
    const values = this.control().value as string[];
    values.splice(index, 1);
    this.control().setValue(values);
  }
}
